export interface TrenchRadarResponse {
  bonded: boolean;
  bundles: { [key: string]: Bundle };
  creator_analysis: CreatorAnalysis;
  distributed_amount: number;
  distributed_percentage: number;
  distributed_wallets: number;
  ticker: string;
  total_bundles: number;
  total_holding_amount: number;
  total_holding_percentage: number;
  total_percentage_bundled: number;
  total_sol_spent: number;
  total_tokens_bundled: number;
}

export interface Bundle {
  bundle_analysis: BundleAnalysis;
  holding_amount: number;
  holding_percentage: number;
  token_percentage: number;
  total_sol: number;
  total_tokens: number;
  unique_wallets: number;
  wallet_categories: WalletCategories;
  wallet_info: { [key: string]: WalletInfo };
}

export interface BundleAnalysis {
  category_breakdown: CategoryBreakdown;
  copytrading_groups: CopytradingGroups;
  is_likely_bundle: boolean;
  primary_category: 'regular' | 'sniper' | 'new_wallet' | 'regular' | 'sniper';
}

export interface CategoryBreakdown {
  new_wallet: number;
  regular: number;
  sniper: number;
}

export interface CopytradingGroups {
  [walletId: string]: string;
}

export enum PrimaryCategory {
  Regular = 'regular',
  Sniper = 'sniper',
}

export interface WalletCategories {
  [walletId: string]: string | PrimaryCategory;
}

export interface WalletInfo {
  sol: number;
  sol_percentage: number;
  token_percentage: number;
  tokens: number;
}

export interface CreatorAnalysis {
  address: string;
  current_holdings: number;
  history: History;
  holding_percentage: number;
  risk_level: string;
  warning_flags: null[];
}

export interface History {
  average_market_cap: number;
  high_risk: boolean;
  previous_coins: PreviousCoin[];
  recent_rugs: number;
  rug_count: number;
  rug_percentage: number;
  total_coins_created: number;
}

export interface PreviousCoin {
  created_at: number;
  is_rug: boolean;
  market_cap: number;
  mint: string;
  symbol: string;
}
